import { PayloadAction } from '@reduxjs/toolkit'
import { SagaIterator } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects'
import { GET_VISUALIZATION_DATA } from './actionTypes'
import { getVisualizationData } from './api'
import {
  addVisualizationData,
  errorVisualizationData,
} from './visualizationDataReducer'
import {
  GetVisualizationDataActionType,
  VisualizationDataEntityType,
  // VisualizationDataEntryType,
  VisualizationDataType
} from './types'

export function* handleVisualizationData(
  actions: PayloadAction<GetVisualizationDataActionType>
): SagaIterator<void> {
  try {
    const response = yield call(
      getVisualizationData,
      actions.payload.patientKey,
      actions.payload.startTime,
      actions.payload.endTime
    )
    const { data } = response.data
    // console.log("Saga Data: ", data)
    let modifiedData: VisualizationDataEntityType = {
      key: actions.payload.patientKey,
      visualizationData: data.map((data: VisualizationDataType) => {
        return {
          ...data,
        }
      }),
    }
    yield put(addVisualizationData(modifiedData))
  } catch (error: any) {
    yield put(errorVisualizationData(error.response.data.message))
  }
}

export function* watcherSaga() {
  yield takeLatest(GET_VISUALIZATION_DATA, handleVisualizationData)
}

export const visualizationDataSaga = [fork(watcherSaga)]
